export function elapsedMonths(fromDate){
    return Math.ceil((new Date() - new Date(fromDate)) / 1000 / 3600 / 24 / 30.5)
}